(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('elbSpillageWorkflowButtons', ElogbooksSpillageWorkflowButtons);

    ElogbooksSpillageWorkflowButtons.$inject = ['modulesService'];

    function ElogbooksSpillageWorkflowButtons (modulesService) {
        return {
            restrict: 'AE',
            scope: true,
            templateUrl: '/modules/directives/elb-spillage-workflow-buttons/spillage-workflow-buttons.html',
            link: function ($scope, element, attributes) {
                $scope.quotesModuleEnabled = modulesService.isEnabled('quotes');
            }
        };
    }
})();
